import React from 'react';
import { Document, Page, Text, StyleSheet, Font } from '@react-pdf/renderer';
import FontFranklinRegular from '../../../../fonts/libre-franklin-v11-latin/libre-franklin-v11-latin-500.ttf';
import FontFranklinBold from '../../../../fonts/libre-franklin-v11-latin/libre-franklin-v11-latin-600.ttf';
import PdfCandidateDetails from '../verification-report/pdf-candidate-details';
import PdfCredentialDetails from '../verification-report/pdf-credential-details';
import PdfDisclaimers from '../verification-report/pdf-disclaimers';
import PdfTitleSection from '../verification-report/pdf-title-section';
import PdfCoverLetterFooter from '../verification-report/pdf-footer';
interface PdfTemplateProps {
  data: any;
}

Font.register({
  family: 'Libre Franklin',
  src: FontFranklinRegular
});

Font.register({
  family: 'Libre Franklin Bold',
  src: FontFranklinBold
});

export const PdfEpicReportInfoPage: React.FC<PdfTemplateProps> = (props) => {
  const styles = StyleSheet.create({
    page: {
      fontFamily: 'Libre Franklin',
      color: 'black',
      paddingLeft: 40,
      paddingRight: 40,
      paddingTop: 30
    },
    divider: {
      borderTop: '1px solid #26867d'
    },
  });

  return (
    <Document>
      <Page style={styles.page}>
        <PdfTitleSection data={props.data} />
        <Text style={styles.divider}></Text>
        <PdfCandidateDetails data={props.data} />
        <PdfCredentialDetails data={props.data} />
        <PdfDisclaimers data={props.data} />
        <PdfCoverLetterFooter data={props.data} />
      </Page>
    </Document>
  );
};
export default PdfEpicReportInfoPage;
